/// <amd-module name="Repos/Views/FilesHub/Components/HistoryContent" />
import * as React from "react";
import { ICommitsHistoryViewProps } from "Repos/Common/Contracts/History";
import { IFilesHubFilterActionsService } from "Repos/FilesHubCommon/FilesHubFilterActionsService";
import * as Resources from "Repos/Views/FilesHub/Resources";
import { IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { PerformanceScenarioContext } from "VSS/Platform/Components/Performance";
import { IVssHistoryService } from "VSS/Platform/History";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { IFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

interface IHistoryContentProps {
    filterVisible: IReadonlyObservableValue<boolean>;
}

class HistoryContent extends VssComponent<IHistoryContentProps> {
    public render() {
        return (
            <PerformanceScenarioContext.Consumer>
                {scenarioProps => {
                    const pendingWork = scenarioProps.registerPendingWork("load-history");
                    const filesService = this.context.pageContext.getService<IFilesHubViewService>("IFilesHubViewService");
                    return (
                        <WrappedComponent<ICommitsHistoryViewProps>
                            wrappedType="repos-commits-history"
                            dependencies={["ms.vss-code-web.commits-list"]}
                            wrappedProps={{
                                filterVisible: this.props.filterVisible,
                                filePath: filesService.getSelectedItem().value.path,
                                isSingleFileHistory: !filesService.getSelectedItem().value.isFolder,
                                onLoaded: pendingWork && pendingWork.complete,
                                shouldUpdateUrl: true,
                                showGraph: true,
                                version: filesService.getVersion()
                            }}
                        />
                    );
                }}
            </PerformanceScenarioContext.Consumer>
        );
    }
}

registerFilesHubTab({
    getTab: (pageContext, item, editMode) => {
        if (!item.isInvalid && !editMode) {
            const actionService = pageContext.getService<IFilesHubFilterActionsService>("IFilesHubFilterActionsService");
            const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
            const state = historyService.getState();
            const filterVisible = new ObservableValue<boolean>(
                Boolean(state["toDate"] || state["fromDate"] || state["user"] || state["historyType"])
            );

            return {
                id: "history",
                name: Resources.History,
                order: 20,
                render: () => <HistoryContent filterVisible={filterVisible} />,
                renderFilterBar: (inTabBar: boolean) => {
                    return inTabBar ? (
                        <HeaderCommandBar
                            items={[
                                {
                                    ariaLabel: Resources.Filter,
                                    iconProps: { iconName: "Filter" },
                                    id: "filter",
                                    onActivate: () => {
                                        filterVisible.value = !filterVisible.value;
                                    },
                                    subtle: true
                                },
                                ...actionService.getActions()
                            ]}
                        />
                    ) : (
                        undefined
                    );
                }
            };
        }
    },
    dependencies: ["ms.vss-code-web.commits-list"]
});
